import { render, staticRenderFns } from "./DashboardLatestBlogs.vue?vue&type=template&id=0cc2e704&scoped=true"
import script from "./DashboardLatestBlogs.vue?vue&type=script&lang=ts"
export * from "./DashboardLatestBlogs.vue?vue&type=script&lang=ts"
import style0 from "./DashboardLatestBlogs.vue?vue&type=style&index=0&id=0cc2e704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2e704",
  null
  
)

export default component.exports